import { Typography } from "antd";

import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { type ClientObservableBackgroundJobDetails } from "commonComponents/utilities/ClientObservableBackgroundJobStatusPopup/ClientObservableBackgroundJobStatusPopup.types";

export function TodoMigrationItem({ process }: { process: ClientObservableBackgroundJobDetails }) {
    return (
        <div>
            <BTTitle level={4} className="TruncateText margin-bottom-zero">
                {process.processName}
            </BTTitle>
            <Typography.Text type="secondary">{process.details}</Typography.Text>
        </div>
    );
}
